/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Input } from '@angular/core';

@Component({
    selector: 'dash-gis-string-field',
    templateUrl: './string-field.component.html',
    styleUrls: ['./string-field.component.scss'],
})
export class StringFieldComponent {
    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
}
